/**
 * Generated from MusicScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function MusicScreenLayout(this: $MusicScreenLayout) {
	$(this, "glockenspiel", glockenspiel, {x:1024, y:768});
	$(this, "nyatiti", nyatiti, {x:1024, y:768});
	$(this, "didgeridoo", didgeridoo, {x:1024, y:768});
	$(this, "bagpipes", bagpipes, {x:1024, y:768});
	return this;
}
export function glockenspiel(this: $glockenspiel) {
	const keysHitAreas = this.keysHitAreas;
	$(keysHitAreas, 0, [-684.65,-244.80,-525.50,-247.80,-403.70,258.35,-437.20,316.85,-590.40,332.55,-611.35,303.75,-710.85,-170.15,-708.70,-211.85]);
	$(keysHitAreas, 1, [-461.00,-242.25,-384.15,-239.55,-311.25,-229.65,-251.50,21.90,-209.45,233.90,-239.70,284.40,-344.90,302.90,-376.00,296.20,-389.60,260.60,-487.90,-185.05,-489.60,-206.95]);
	$(keysHitAreas, 2, [-257.40,-228.80,-119.45,-220.40,-10.05,200.25,-30.25,241.45,-155.60,263.35,-174.95,257.45,-197.30,177.00,-277.60,-182.55,-278.45,-196.45]);
	$(keysHitAreas, 3, [-66.45,-217.05,75.75,-202.75,180.05,168.30,169.15,197.70,30.30,225.50,21.05,216.25,-52.15,-58.85,-83.25,-190.95]);
	$(keysHitAreas, 4, [120.85,-192.10,129.60,-207.75,254.10,-201.85,355.90,137.15,345.80,158.20,333.20,165.60,226.35,182.60,206.65,176.55,115.80,-169.25]);
	$(keysHitAreas, 5, [309.90,-199.55,424.00,-191.75,514.05,110.25,505.65,136.35,477.85,143.90,394.60,155.70,380.10,145.40,299.90,-149.35,297.00,-171.60]);
	$(keysHitAreas, 6, [461.80,-188.45,566.15,-189.30,657.30,84.95,638.50,108.55,554.35,122.85,533.30,117.80,455.45,-151.75]);
	$(keysHitAreas, 7, [593.95,-195.90,683.50,-192.60,779.25,66.45,762.25,86.85,680.85,102.40,670.25,94.65,589.35,-146.70,587.20,-158.95]);
	$(this, "sprite", glockenspielSprite, {x:-790, y:-248, w:1613.00, h: 630.00});
	return this;
}
function glockenspielSprite(this: $glockenspielSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("glockenspiel.png", 0.000, 0.000);
	return this;
}
function keysHitAreas0(this: $keysHitAreas0) {
	return this;
}
function keysHitAreas1(this: $keysHitAreas1) {
	return this;
}
function keysHitAreas2(this: $keysHitAreas2) {
	return this;
}
function keysHitAreas3(this: $keysHitAreas3) {
	return this;
}
function keysHitAreas4(this: $keysHitAreas4) {
	return this;
}
function keysHitAreas5(this: $keysHitAreas5) {
	return this;
}
function keysHitAreas6(this: $keysHitAreas6) {
	return this;
}
function keysHitAreas7(this: $keysHitAreas7) {
	return this;
}
export function nyatiti(this: $nyatiti) {
	$(this, "sprite", nyatitiSprite, {x:-196.85, y:215.5, w:1303.00, h: 1187.00});
	return this;
}
function nyatitiSprite(this: $nyatitiSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("nyatiti.png", 0.302, 0.700);
	return this;
}
export function didgeridoo(this: $didgeridoo) {
	$(this, "sprite", didgeridooSprite, {x:546.3, y:613.55, r:-0.6982});
	return this;
}
function didgeridooSprite(this: $didgeridooSprite) {
	$(this, "hitAreaPoints", [-124.05,-1745.70,-60.70,-1774.00,39.85,-1759.75,132.75,-1663.95,100.15,-874.35,163.45,20.20,49.65,97.60,-63.55,100.60,-178.60,28.20,-209.45,-872.30,-173.65,-1693.05]);
	$(this, "sprite", didgeridooSprite1, {x:-23, y:-833, w:244.00, h: 1775.00});
	return this;
}
function didgeridooHitArea(this: $didgeridooHitArea) {
	return this;
}
function didgeridooSprite1(this: $didgeridooSprite1) {
	if (this.setLayoutTexture) this.setLayoutTexture("didgeridoo.png", 0.500, 0.500);
	return this;
}
export function bagpipes(this: $bagpipes) {
	$(this, "button", bagpipesInstrument, {x:0, y:0});
	return this;
}
function bagpipesInstrument(this: $bagpipesInstrument) {
	const items = this.items;
	$(items, 0, bagpipesString1, {x:184.25, y:-358.9, w:142.00, h: 158.00});
	$(items, 1, bagpipesString2, {x:392.7, y:-280.05, w:210.00, h: 71.00});
	$(items, 2, bagpipesString3, {x:523.15, y:-266.1, w:148.00, h: 505.00});
	$(items, 3, bagpipesPipe1, {x:-241.55, y:60.05, w:145.00, h: 509.00});
	$(items, 4, bagpipesPipe2, {x:-130.15, y:157.95, w:58.00, h: 397.00});
	$(items, 5, bagpipesPipe3, {x:-24.6, y:175, w:270.00, h: 858.00});
	$(items, 6, bagpipesPipe4, {x:82.5, y:175.3, w:388.00, h: 681.00});
	$(items, 7, bagpipesPipe5, {x:241.05, y:157.7, w:443.00, h: 612.00});
	$(items, 8, bagpipesBagBottom, {x:37.7, y:344.6, w:703.00, h: 420.00});
	$(items, 9, bagpipesBagTop, {x:-220.3, y:253.8, w:204.00, h: 234.00});
	const startItems = this.startItems;
	$(startItems, 0, bagpipesString1, {x:195.15, y:-295, w:116.80, h: 129.96});
	$(startItems, 1, bagpipesString2, {x:340.65, y:-209.4, r:0.3981, w:189.79, h: 64.17});
	$(startItems, 2, bagpipesString3, {x:416, y:-168.75, r:0.1766, w:147.99, h: 504.98});
	$(startItems, 3, bagpipesPipe1, {x:-215.3, y:124.7, r:0.3304, w:145.00, h: 508.99});
	$(startItems, 4, bagpipesPipe2, {x:-129.85, y:225.65, r:0.1436, w:58.00, h: 397.00});
	$(startItems, 5, bagpipesPipe3, {x:-24.7, y:243.55, r:0.0509, w:270.00, h: 858.00});
	$(startItems, 6, bagpipesPipe4, {x:59.25, y:271.5, r:-0.0204, w:387.99, h: 680.99});
	$(startItems, 7, bagpipesPipe5, {x:164.5, y:279.8, r:-0.0527, w:443.01, h: 612.01});
	$(startItems, 8, bagpipesBagBottom, {x:13.15, y:361.55, r:0.1075, w:702.99, h: 324.40});
	$(startItems, 9, bagpipesBagTop, {x:-237.7, y:250.75, r:0.3265, w:199.71, h: 154.95});
	const notes = this.notes;
	$(notes, 0, notesPoints, {x:118.75, y:-635.35, w:200.00, h:100.00});
	$(notes, 1, notesPoints, {x:321.9, y:-441.05, w:200.00, h:100.00});
	$(notes, 2, notesPoints, {x:569.65, y:-377.65, w:200.00, h:100.00});
	$(this, "hitAreaPoints", [-168.60,-494.25,5.85,-703.60,191.95,-718.15,686.20,-444.80,692.00,-345.95,683.30,186.10,325.65,543.75,110.50,578.65,-157.00,526.30,-325.60,404.15,-363.45,261.70,-407.05,-447.75]);
	return this;
}
function bagpipesHitArea(this: $bagpipesHitArea) {
	return this;
}
function bagpipesString3(this: $bagpipesString3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-string-3.png", 0.061, 0.022);
	return this;
}
function bagpipesString2(this: $bagpipesString2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-string-2.png", 0.500, 0.500);
	return this;
}
function bagpipesString1(this: $bagpipesString1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-string-1.png", 0.500, 0.500);
	return this;
}
function bagpipesPipe5(this: $bagpipesPipe5) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-5.png", 0.102, 0.974);
	return this;
}
function bagpipesPipe4(this: $bagpipesPipe4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-4.png", 0.183, 0.988);
	return this;
}
function bagpipesPipe3(this: $bagpipesPipe3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-3.png", 0.130, 0.997);
	return this;
}
function bagpipesPipe2(this: $bagpipesPipe2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-2.png", 0.448, 0.980);
	return this;
}
function bagpipesPipe1(this: $bagpipesPipe1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-pipe-1.png", 0.848, 0.984);
	return this;
}
function bagpipesBagBottom(this: $bagpipesBagBottom) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-bag-bottom.png", 0.500, 0.500);
	return this;
}
function bagpipesBagTop(this: $bagpipesBagTop) {
	if (this.setLayoutTexture) this.setLayoutTexture("bagpipes-bag-top.png", 0.637, 0.996);
	return this;
}
function notesPoints(this: $notesPoints) {
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $MusicScreenLayout {
	readonly glockenspiel: $glockenspiel;
	readonly nyatiti: $nyatiti;
	readonly didgeridoo: $didgeridoo;
	readonly bagpipes: $bagpipes;
}
interface $glockenspiel extends $$container {
	readonly keysHitAreas: $$array<$keysHitAreas0|$keysHitAreas1|$keysHitAreas2|$keysHitAreas3|$keysHitAreas4|$keysHitAreas5|$keysHitAreas6|$keysHitAreas7>;
	readonly sprite: $glockenspielSprite;
}
interface $glockenspielSprite extends $$sprite {
}
interface $keysHitAreas0 extends $$polygon {
}
interface $keysHitAreas1 extends $$polygon {
}
interface $keysHitAreas2 extends $$polygon {
}
interface $keysHitAreas3 extends $$polygon {
}
interface $keysHitAreas4 extends $$polygon {
}
interface $keysHitAreas5 extends $$polygon {
}
interface $keysHitAreas6 extends $$polygon {
}
interface $keysHitAreas7 extends $$polygon {
}
interface $nyatiti extends $$container {
	readonly sprite: $nyatitiSprite;
}
interface $nyatitiSprite extends $$sprite {
}
interface $didgeridoo extends $$container {
	readonly sprite: $didgeridooSprite;
}
interface $didgeridooSprite extends $$container {
	readonly hitAreaPoints: $didgeridooHitArea;
	readonly sprite: $didgeridooSprite1;
}
interface $didgeridooHitArea extends $$polygon {
}
interface $didgeridooSprite1 extends $$sprite {
}
interface $bagpipes extends $$container {
	readonly button: $bagpipesInstrument;
}
interface $bagpipesInstrument extends $$container {
	readonly items: $$array<$bagpipesString1|$bagpipesString2|$bagpipesString3|$bagpipesPipe1|$bagpipesPipe2|$bagpipesPipe3|$bagpipesPipe4|$bagpipesPipe5|$bagpipesBagBottom|$bagpipesBagTop>;
	readonly startItems: $$array<$bagpipesString1|$bagpipesString2|$bagpipesString3|$bagpipesPipe1|$bagpipesPipe2|$bagpipesPipe3|$bagpipesPipe4|$bagpipesPipe5|$bagpipesBagBottom|$bagpipesBagTop>;
	readonly notes: $$array<$notesPoints>;
	readonly hitAreaPoints: $bagpipesHitArea;
}
interface $bagpipesHitArea extends $$polygon {
}
interface $bagpipesString3 extends $$sprite {
}
interface $bagpipesString2 extends $$sprite {
}
interface $bagpipesString1 extends $$sprite {
}
interface $bagpipesPipe5 extends $$sprite {
}
interface $bagpipesPipe4 extends $$sprite {
}
interface $bagpipesPipe3 extends $$sprite {
}
interface $bagpipesPipe2 extends $$sprite {
}
interface $bagpipesPipe1 extends $$sprite {
}
interface $bagpipesBagBottom extends $$sprite {
}
interface $bagpipesBagTop extends $$sprite {
}
interface $notesPoints extends $$container {
}
